import uid from "common/utils/uid";
import type { DocMigration } from "../docMigration";

// eslint-disable-next-line @typescript-eslint/naming-convention
const migration_0_0_491: DocMigration = {
  maxSchemaVersion: "0.0.491",
  description: "Migrate local porch settings to targeted settings for porch rooms",
  apply(json: any) {
    if (!json.settingsSets) {
      json.settingsSets = {};
    }
    if (!json.entitySettings) {
      json.entitySettings = {};
    }

    for (const id in json.settings) {
      const setting = json.settings[id];
      if (setting.type !== "PORCH_SETTINGS" && setting.type !== "REAR_PORCH_SETTINGS") {
        continue;
      }
      // We only care about local porch settings which have a room as their parent
      if (!json.rooms[setting.parentId]) {
        continue;
      }
      const room = json.rooms[setting.parentId];
      if (room.type !== "FRONT_PORCH" && room.type !== "REAR_PORCH") {
        continue;
      }
      const roomId = room.id;
      const settingsSetId = uid();
      json.settingsSets[settingsSetId] = {
        entityType: "SETTINGS_SET",
        type: "TARGETED",
        name: setting.type === "PORCH_SETTINGS" ? `${room.name} Porch Settings` : `${room.name} Rear Porch Settings`,
        id: settingsSetId,
        sortIndex: 0,
      };
      json.settings[id].parentId = settingsSetId;
      const entitySettingsId = uid();
      json.entitySettings[entitySettingsId] = {
        entityType: "ENTITY_SETTINGS",
        entityId: roomId,
        name: `${room.name} Entity Porch Settings`,
        settingsOrSettingsSetId: id,
        id: entitySettingsId,
        sortIndex: 0,
      };
    }

    return json;
  },
};

export default migration_0_0_491;
